import { Button, Grid } from '@mui/material'
import React from 'react'
import SubCard from 'ui-component/cards/SubCard'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import { IoMdArrowBack } from "react-icons/io";
import TableHead from '@mui/material/TableHead';
import DsListTable from './SHTable';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import {  postTmShRequest } from 'API/Mapping/api';



const MappingDetails = (props) => {
    const [Selected, setSelected] = useState(null)
    const [open, setOpen] = React.useState(false);
    const[openErr,setOpenErr]=useState(false)
    const[ErrMessage,setErrorMessage] = useState(null)

    const handleClick = () => {
        setOpen(true);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
        setOpenErr(false)
    };

    const handleError=()=>{
        setOpenErr(true)
    }



    const handleChange = (newValue) => {
        setSelected(newValue);
        if (newValue) {
            console.log(newValue);
        }
    };

    const handleMap = () => {
        console.log(props.selected);
        console.log(Selected);
        postTmShRequest({
            "tm_id": props.selected._id,
            "sh_id": Selected._id
          },

          handleClick,
          handleError,
          setErrorMessage,
          props.handleBack
        )
        console.log(Selected);
    }

    console.log("props", props);
    return (
        <Grid container justifyContent='space-between' alignItems='center' mt={0}>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{horizontal:'right',vertical:'top'}}>
                <Alert
                    onClose={handleClose}
                    severity="success"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    Mapped Seccessfuly
                </Alert>
            </Snackbar>
            <Snackbar open={openErr} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{horizontal:'right',vertical:'top'}}>
                <Alert
                    onClose={handleClose}
                    severity="error"
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                   {ErrMessage}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xl={2}>
                    <Button variant='outlined' onClick={props.handleBack}><IoMdArrowBack /></Button>
                </Grid>
            </Grid>
            <Grid container direction='column' mt={3} gap={5} alignItems='stretch'>
                <Grid item xl={12}>
                    <SubCard title="TM" >
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 1000 }} aria-label="simple table" size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>TM id</TableCell>
                                        <TableCell align="right">MDS Name</TableCell>
                                        <TableCell align="right">Mobile Number</TableCell>
                                        <TableCell align="right">Location</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow

                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell component="th" scope="row">
                                            {props.selected._id}
                                        </TableCell>
                                        <TableCell align="right">{props.selected.username}</TableCell>
                                        <TableCell align="right">{props.selected.mobile}</TableCell>
                                        <TableCell align="right">{props.selected.district + " " + props.selected.sub_district}</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </SubCard>
                </Grid>

                <Grid item xl={5}>
                    <SubCard title='SH' sx={{ height: '100%', overflow: 'scroll', scrollbarWidth: 'none' }}>
                        <Grid container>

                            <Grid item xl={12}>
                                {
                                    Selected ?
                                        <TableContainer component={Paper}>
                                            <Table sx={{ minWidth: 200 }} aria-label="simple table" size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell align="left">SH Id</TableCell>
                                                        <TableCell align="left">SH Name</TableCell>
                                                        <TableCell align="left">Mobile Number</TableCell>
                                                        <TableCell align="left">Email</TableCell>
                                                        <TableCell align="left">Location</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>

                                                        <TableCell align="left">{Selected._id}</TableCell>
                                                        <TableCell align="left">{Selected.username}</TableCell>
                                                        <TableCell align="left">{Selected.mobile}</TableCell>
                                                        <TableCell align="left">{Selected.emailid}</TableCell>
                                                        <TableCell align="left">{Selected.district}</TableCell>


                                                    </TableRow>

                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                        :
                                        <DsListTable  handleChange={handleChange} />
                                }
                            </Grid>
                        </Grid>
                    </SubCard>
                </Grid>
            </Grid>
            <Grid container sx={{ mt: 1, mb: 1 }}>
                <Grid item xl={10}></Grid>
                <Grid item xl={2}>
                    <Button variant='contained' color='secondary' onClick={()=>handleMap()}>Map</Button>
                </Grid>

            </Grid>
        </Grid>
    )
}

export default MappingDetails
